
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14.503 14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","stroke":"currentColor","stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"M13.302 4.842a1.23 1.23 0 00-.253-.028h-.638v-.529a1.207 1.207 0 00-1.208-1.208H5.356l-1.6-1.294-.1-.034H1.465A1.208 1.208 0 00.257 2.956v8.279a1.207 1.207 0 00.88 1.156l.1.034h10.66a1.207 1.207 0 001.19-.949l1.139-5.192a1.208 1.208 0 00-.924-1.442zM1.113 12.007a.863.863 0 01-.517-.794V2.957a.862.862 0 01.862-.863H3.58l1.6 1.294.1.034h5.916a.863.863 0 01.863.863v.529H4.038a1.207 1.207 0 00-1.156.88zm12.782-5.813l-1.156 5.209a.863.863 0 01-.845.673H1.458l1.759-6.3a.863.863 0 01.828-.638h9a.862.862 0 01.866.859.837.837 0 01-.017.197z","stroke-width":".5"}}),_c('path',{attrs:{"d":"M6.429 6.938l3.2 1.824-3.2 1.836v-3.66m-.262-.71c-.163 0-.276.13-.276.352v4.377c0 .222.112.351.274.351a.444.444 0 00.218-.066l3.835-2.2a.3.3 0 000-.564L6.384 6.293a.44.44 0 00-.217-.066z","stroke-width":".2"}})])])
          )
        }
      }
    